import paronApi from '@/utils/paron-api'

export default {
    getAllVouchers(page) {
        var path = page ? `voucher/all?page=${page}&per_page=10` : 'voucher/all'
        return paronApi.get(path)
    },

    getVoucherById(id) {
        return paronApi.get(`voucher/${id}`)
    },

    createVoucher(data) {
        return paronApi.post('voucher/new', data)
    },

    editVoucherById(id, data) {
        return paronApi.post(`voucher/${id}/edit`, data)
    },

    deleteVoucherById(id) {
        return paronApi.delete(`voucher/${id}`)
    },
    getVouchersByFilter(page, filter, perPage = 10) {
        return paronApi.post(`voucher/filtered?page=${page || 1}&per_page=${perPage}`, filter)
    }

}
